import { Action } from '@ngrx/store';
import { SirenResponse } from '@awp/http';
import { CorrelationAction, AggregatableAction } from '@awp/core/ngrx';

export enum ActionTypes {
  AUTHENTICATE = '[Data] Authenticate',
  SIREN_RESPONSE = '[Data] Siren Response',
  RESET_ALL_DATA = '[Data] Reset Response',
  RESET_DATA = '[Data] Reset Data',
}

export class SirenResponseAction implements Action {
  readonly type = ActionTypes.SIREN_RESPONSE;
  constructor(public payload: { id: string, response: SirenResponse }) { }
}

export class ResetAllDataAction implements Action {
  static TYPE = ActionTypes.RESET_ALL_DATA;
  readonly type = ActionTypes.RESET_ALL_DATA;
}

export class AuthenticateAction implements Action {
  readonly type = ActionTypes.AUTHENTICATE;
}

export class ResetDataAction extends CorrelationAction implements AggregatableAction {
  static TYPE = ActionTypes.RESET_DATA;
  readonly type = ActionTypes.RESET_DATA;
  constructor(id?: string) {
    super(id);
  }
}

export type Actions = SirenResponseAction | ResetAllDataAction | AuthenticateAction | ResetDataAction;